import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { FilterAltOff } from "@mui/icons-material";

const TransformDictionaryFilterDialog = ({
  anchorEl,
  open,
  onClose,
  filterData,
  setFilterData,
  onApply,
}) => {
  const handleChange = ({ target: { name, value } }) => {
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onClearFilters = () => {
    setFilterData({
      isActive: "",
    });
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
      PaperProps={{
        elevation: 3,
        sx: {
          width: 220,
          padding: 1.5,
        },
      }}
    >
      <MaterialBox
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Title */}
        <MaterialTypography variant="body2" fontWeight="bold">
          Transform Function Filter
        </MaterialTypography>

        {/* Clear Button */}
        <Tooltip title="Clear Filter" disableInteractive>
          <IconButton
            size="small"
            onClick={onClearFilters}
            sx={{ color: "#ce0707ff" }}
          >
            <FilterAltOff />
          </IconButton>
        </Tooltip>
      </MaterialBox>

      {/* Content */}
      <MaterialBox ml={1}>
        <Grid2 container spacing={1}>
          <Grid2 size={{ xs: 12 }}>
            <MaterialBox>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Active Status
              </MaterialTypography>
            </MaterialBox>
            <MaterialBox ml={1}>
              <MenuItem
                onClick={() =>
                  handleChange({
                    target: { name: "isActive", value: true },
                  })
                }
              >
                <FormControlLabel
                  sx={{
                    m: 0,
                    "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
                  }}
                  control={
                    <Checkbox
                      size="small"
                      checked={filterData.isActive === true}
                    />
                  }
                  label="Active"
                />
              </MenuItem>
              <MenuItem
                onClick={() =>
                  handleChange({
                    target: { name: "isActive", value: false },
                  })
                }
              >
                <FormControlLabel
                  sx={{
                    m: 0,
                    "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
                  }}
                  control={
                    <Checkbox
                      size="small"
                      checked={filterData.isActive === false}
                    />
                  }
                  label="Inactive"
                />
              </MenuItem>
            </MaterialBox>
          </Grid2>
        </Grid2>
      </MaterialBox>

      <Divider />

      {/* Apply button */}
      <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
          padding: "6px 16px",
          width: "fit-content",
          minWidth: "0px",
          mx: "auto",
          borderRadius: "6px",
          backgroundColor: "#bcc7e9",
          color: "white",
          display: "flex",
          justifyContent: "center",
          transition: "0.2s ease",

          "&:hover": {
            backgroundColor: "#93a6e8",
          },
        }}
      >
        <MaterialTypography variant="button" fontWeight="bold">
          APPLY FILTER
        </MaterialTypography>
      </MenuItem>
    </Menu>
  );
};

export default TransformDictionaryFilterDialog;
